import React from 'react';
import { Flex, Heading } from '@chakra-ui/react';

import AnimatedLogo from '@/components/0-reusable-components/animated-logo';

import style from './index.module.scss';

export const PageLoading = ({ text }: { text?: string }): React.ReactElement => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Complex union type with Chakra UI components
  <Flex className={style['loading-wrapper']} alignItems='center' justifyContent='center'>
    <Flex flexDirection='column' alignItems='center'>
      <AnimatedLogo />
      <Heading textAlign='center' maxWidth='50vw'>{text}</Heading>
    </Flex>
  </Flex>
);
